import { createEngagement } from '@/entities/engagement';
export async function createEngagementAction(input) {
    await createEngagement(input);
}
